import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderStatusHistory(id: string) {
  return useQuery(queryKeys.welder.statusHistory(id), () => {
    return api.getWelderStatusHistory(id);
  });
}

export function useWelderProcessStatus(id: string) {
  return useQuery(queryKeys.welder.processStatus(id), async () => {
    const data = await api.getWelderProcessStatus(id);
    // Remove time portion so it works with the HTML date input.
    return data.map((x) => ({ ...x, retestDate: x.retestDate?.substring(0, 10) }));
  });
}
